/* Rebuy Smart Cart redesign. Rebuy re-renders its own nodes, so we never edit them:
   originals stay in place (some hidden by CSS) and we add sibling elements marked .sn-*. */
(function () {
  var FREE = 99, FROM = '$6.73', FX = {}, LOCK = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M4 7V5a4 4 0 1 1 8 0v2h1v8H3V7zm2 0h4V5a2 2 0 1 0-4 0z"/></svg>';
  function money(s) { var m = String(s || '').replace(/[^0-9.]/g, ''); return m ? parseFloat(m) : 0; }
  function fmt(n) { return '$' + n.toFixed(2); }
  function txt(el) { return el ? el.textContent.trim() : ''; }
  function sib(anchor, cls, tag, where) {
    var el = anchor.parentElement.querySelector(':scope > .' + cls);
    if (!el) { el = document.createElement(tag || 'div'); el.className = cls; anchor.insertAdjacentElement(where || 'afterend', el); }
    return el;
  }
  function set(el, html) { if (el.innerHTML !== html) el.innerHTML = html; }
  function variant(s) {
    return s.split(/\s+[-/]\s+/).map(function (p, i) { return i ? p.charAt(0) + p.slice(1).toLowerCase() : p; }).join(' · ')
      .replace(/(^|· )([a-z])/g, function (m, a, b) { return a + b.toUpperCase(); });
  }
  function handleOf(el) {
    var a = el.querySelector('a[href*="/products/"]');
    if (a) return a.getAttribute('href').split('/products/')[1].split(/[?#/]/)[0];
    var m = String(el.className).match(/(?:^|\s)product-(?!id-)([a-z0-9-]+)/);
    return m ? m[1] : '';
  }
  // Same estimate as the product page: ships next business day (Fri/Sat orders ship Monday), arrives 2 business days later.
  function deliveryDate() {
    var now = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Los_Angeles' }));
    var d = new Date(now), day = now.getDay();
    d.setDate(d.getDate() + (day === 5 ? 3 : day === 6 ? 2 : 1));
    for (var added = 0; added < 2;) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) added++; }
    return ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][d.getDay()] + ', ' +
      ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][d.getMonth()] + ' ' + d.getDate();
  }
  var TRUCK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h11v9H3zM14 9h4l3 3v3h-7"/><circle cx="7" cy="17" r="1.6"/><circle cx="17.5" cy="17" r="1.6"/></svg>';
  window.snDeliveryDate = deliveryDate;
  document.querySelectorAll('[data-sn-delivery]').forEach(function (el) { el.textContent = deliveryDate(); });
  function tile(el, handle) {
    if (!handle) return;
    if (handle in FX) { if (FX[handle]) el.style.setProperty('--sn-fx', 'var(--effect-color-' + FX[handle] + ')'); return; }
    FX[handle] = '';
    fetch('/products/' + handle + '?view=sn-effect').then(function (r) { return r.ok ? r.text() : ''; }).then(function (t) {
      FX[handle] = String(t).trim().replace(/[^a-z-]/g, ''); schedule();
    }).catch(function () {});
  }
  function render() {
    var fly = document.querySelector('.rebuy-cart__flyout');
    if (!fly) return;
    var sub = fly.querySelector('.rebuy-cart__flyout-subtotal');
    var amt = sub ? money(txt(sub.querySelector('.rebuy-cart__flyout-subtotal-amount span:not(.sr-only)'))) : 0;
    var count = sub ? (txt(sub.querySelector('.rebuy-cart__flyout-subtotal-label')).match(/\d+/) || [''])[0] : '';
    var free = amt >= FREE;

    var title = fly.querySelector('.rebuy-cart__title');
    if (title) {
      var t2 = sib(title, 'sn-cart-title', 'h2');
      set(t2, 'Your cart' + (count ? ' <span>(' + count + ')</span>' : ''));
      set(sib(t2, 'sn-cart-stars'), '<i>★★★★★</i> 30,000+ five-star reviews');
    }

    var prompt = fly.querySelector('.rebuy-cart__progress-bar-prompt');
    if (prompt) {
      var m = txt(prompt).match(/\$[\d,.]+/);
      set(sib(prompt, 'sn-cart-goal'), free || !m ? '✓ You’ve unlocked <b>free shipping</b>' : 'You’re <b>' + m[0] + '</b> away from free shipping');
    }

    fly.querySelectorAll('.rebuy-cart__flyout-item').forEach(function (li) {
      var v = li.querySelector('.rebuy-cart__flyout-item-variant-title');
      if (v) set(sib(v, 'sn-cart-var'), variant(txt(v)));
      var media = li.querySelector('.rebuy-cart__flyout-item-media');
      if (media) tile(media, handleOf(li));
    });

    var rec = fly.querySelector('.rebuy-widget.widget-type-cart');
    if (rec) {
      var inCart = {};
      fly.querySelectorAll('.rebuy-cart__flyout-item').forEach(function (li) { inCart[handleOf(li)] = 1; });
      var gap = FREE - amt, slides = [];
      rec.querySelectorAll('.splide__slide:not(.is-clone)').forEach(function (b) {
        var media = b.querySelector('.rebuy-product-media');
        var hd = handleOf(b);
        if (media) tile(media, hd);
        slides.push({ el: b, h: hd, price: money(txt(b.querySelector('.rebuy-product-price span:not(.sr-only)'))) });
      });
      var pool = slides.filter(function (x) { return !inCart[x.h]; });
      var closers = free ? [] : pool.filter(function (x) { return x.price >= gap; }).sort(function (a, b) { return a.price - b.price; });
      var pick = closers.concat(pool.filter(function (x) { return closers.indexOf(x) < 0; })).slice(0, 2);
      slides.forEach(function (x) {
        var i = pick.indexOf(x), unlock = !free && x.price >= gap;
        if (i < 0) { if (x.el.getAttribute('data-sn-hide') !== '1') x.el.setAttribute('data-sn-hide', '1'); }
        else { if (x.el.hasAttribute('data-sn-hide')) x.el.removeAttribute('data-sn-hide'); if (x.el.style.order !== String(i)) x.el.style.order = i; }
        var info = x.el.querySelector('.rebuy-product-info');
        if (info) {
          var u = info.querySelector(':scope > .sn-cart-unlock');
          if (unlock && !u) { u = document.createElement('span'); u.className = 'sn-cart-unlock'; u.textContent = 'unlocks free shipping'; info.appendChild(u); }
          if (!unlock && u) u.remove();
        }
      });
      var h = rec.querySelector(':scope > .sn-cart-rec-title');
      if (!h) { h = document.createElement('div'); h.className = 'sn-cart-rec-title'; rec.insertAdjacentElement('afterbegin', h); }
      set(h, closers.length ? 'Add one for free shipping' : 'Customers also add');
      rec.style.display = pick.length ? '' : 'none';
    }

    if (sub) {
      var lab = sub.querySelector('.rebuy-cart__flyout-subtotal-label');
      var labSpan = lab && lab.querySelector(':scope > span:not(.sn-cart-sublabel)');
      if (labSpan) set(sib(labSpan, 'sn-cart-sublabel', 'span'), 'Subtotal');
      var ship = sub.parentElement.parentElement.querySelector('.sn-cart-ship');
      if (!ship) { ship = document.createElement('div'); ship.className = 'sn-cart-ship'; sub.parentElement.insertAdjacentElement('afterend', ship); }
      var cs = getComputedStyle(sub.parentElement); ship.style.paddingLeft = cs.paddingLeft; ship.style.paddingRight = cs.paddingRight;
      set(ship, '<span>Shipping</span><span>' + (free ? 'Free' : '<em>from</em> ' + FROM) + '</span>');
      var del = ship.parentElement.querySelector(':scope > .sn-cart-delivery');
      if (!del) { del = document.createElement('div'); del.className = 'sn-cart-ship sn-cart-delivery'; ship.insertAdjacentElement('afterend', del); }
      del.style.paddingLeft = ship.style.paddingLeft; del.style.paddingRight = ship.style.paddingRight;
      var pre = window.snPreDelivery && window.snPreDelivery(); // [label, date] while the cart ships with a pre-order (sn-preorder-cart.js)
      set(del, '<span class="sn-truck">' + TRUCK + (pre ? pre[0] : 'Arrives by') + '</span><span>' + (pre ? pre[1] : deliveryDate()) + '</span>');
    }
    var btn = fly.querySelector('button.btn.green');
    if (btn && amt) {
      btn.classList.add('sn-cart-checkout');
      var orig = btn.querySelector(':scope > span:not(.sn-cart-btn)');
      if (orig) set(sib(orig, 'sn-cart-btn', 'span'), LOCK + 'Checkout · ' + fmt(amt));
      var sz = btn.parentElement.parentElement.querySelector('.sn-cart-sezzle');
      if (!sz) { sz = document.createElement('div'); sz.className = 'sn-cart-sezzle'; btn.parentElement.insertAdjacentElement('afterend', sz); }
      set(sz, 'or 4 interest-free payments of ' + fmt(Math.ceil(amt * 25) / 100) + ' with <b>sezzle</b>');
      var xp = document.getElementById('sn-express-buttons');
      if (xp && xp.parentElement !== btn.parentElement.parentElement) sz.insertAdjacentElement('afterend', xp);
      if (!btn.parentElement.parentElement.querySelector('.sn-cart-trust')) {
        var t = document.createElement('div'); t.className = 'sn-cart-trust';
        t.innerHTML = '<div class="sn-cart-cards"><span class="v">VISA</span><span class="mc"><i></i><i></i></span><span class="ax">AMEX</span><span class="ds">DISCOVER</span></div>' +
          '<p><b>30-day satisfaction guarantee</b> · Tracked USPS shipping</p>';
        (document.getElementById('sn-express-buttons') || sz).insertAdjacentElement('afterend', t);
      }
    }
  }
  var queued = false;
  function schedule() { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; render(); }); }
  window.snCartRefresh = schedule;
  new MutationObserver(function (list) {
    for (var i = 0; i < list.length; i++) {
      var n = list[i].target; if (n.nodeType !== 1) n = n.parentElement;
      if (n && n.closest && n.closest('.rebuy-cart') && !(n.closest('[class^="sn-cart"]'))) return schedule();
    }
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  schedule();
})();
